import {
  ILocationWarningState,
  ILocationWarningType,
  IWarning,
  IWeatherWarningsState,
  WarningLoadingState,
} from 'redux-state/weather-warnings/types.js';
import { PageLocationSummary } from 'types/markerTypes/location.page.js';

export enum WarningType {
  Severe = 'severe',
  Warning = 'warning',
  Watch = 'watch',
  Caution = 'caution',
  Delays = 'delays',
}

export const warningTypeMap: {
  [T in WarningType]: {
    className: string;
  };
} = {
  [WarningType.Severe]: {
    className: 'warning-red',
  },
  [WarningType.Warning]: {
    className: 'warning-orange',
  },
  [WarningType.Watch]: {
    className: 'warning-yellow',
  },
  [WarningType.Caution]: {
    className: 'caution',
  },
  [WarningType.Delays]: {
    className: 'delays',
  },
};

/** Builds unique identifier from warning */
export const buildDataSlug = (w: IWarning): string => {
  const { regions, icon, capId } = w;
  const start = capId ?? regions?.map((a) => a.toLowerCase())?.join('-');
  return `${start}-${icon}`.replace(' ', '-');
};

/** Build key to search for weather property in weather warning state */
export function lookupWeatherTypeKey({ type, key }: Partial<ILocationWarningType> | undefined = {}): string {
  return `${type ?? 'UNDEFINED'}-${key ?? 'UNDEFINED'}`;
}

/** Get Weather Data from state based on location */
export function getCurrentLocationWarnings(
  { type, key }: Partial<ILocationWarningType | PageLocationSummary>,
  warnings: IWeatherWarningsState['warnings'] | Readonly<IWeatherWarningsState['warnings']>,
): Readonly<ILocationWarningState> | undefined {
  const prop = lookupWeatherTypeKey({ type, key });
  const warningState = warnings?.[prop] as Readonly<ILocationWarningState> | undefined;
  return warningState;
}

/** Get Content Per Category From Location */
export const getLoadedLocationWarnings = (
  { type, key }: Readonly<Partial<ILocationWarningType>>,
  warnings: Readonly<IWeatherWarningsState['warnings']>,
): Readonly<ILocationWarningState> | undefined => {
  const warningState = getCurrentLocationWarnings({ type, key }, warnings);
  if (warningState?.loadState === WarningLoadingState.loaded) {
    return warningState;
  }
  return undefined;
};
